import React, { useState } from 'react'
import { Dropdown, Button, DynamicIcon, Anchor } from 'legion-ui'
import './style.scss'

const ExampleTwo = () => {
  const [isOpen, setOpen] = useState(false)
  const toogle = () => setOpen(prev => !prev)
  const onClose = () => setOpen(false)

  return (
    <Dropdown 
      trigger={<Button onClick={toogle} iconRight={<DynamicIcon name="ChevronDown" />}>Select</Button>}
      onClose={onClose}
      isOpen={isOpen}
      borderRadius={8}
      position='center'
    >
      <div className="example-body">
        <Anchor iconLeft={<DynamicIcon name="FilePlus" />}>New File</Anchor>
        <Anchor iconLeft={<DynamicIcon name="Eye" />}>View Detail</Anchor>
        <Anchor iconLeft={<DynamicIcon name="Edit" />}>Edit File</Anchor>
        <Anchor iconLeft={<DynamicIcon name="Star" />}>Save to Favorite</Anchor>
      </div>
      <div className="example-footer">
        <Anchor iconLeft={<DynamicIcon name="Trash2" />}>Delete File</Anchor>
      </div>
    </Dropdown>
  )
}

export default ExampleTwo